import { memo, useCallback, useEffect, useRef, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import CircularProgress from '../components/circularProgress';
import Confirm from '../components/Confirm';
import Cover from '../components/Cover';
import Unsubscribe from '../components/Unsubscribe';
import OrganizationService from '../services/organizationService';
import SubscriptionService from '../services/subscriptionService';

const Home = memo(({ data }) => {
    const isDesktopOrLaptop = useMediaQuery({ minWidth: 1224 });
    const [channel, setChannel] = useState('');
    const [channelURL, setChannelURL] = useState('');
    const [config, setConfig] = useState(null);
    const [organizationLoading, setOrganizationLoading] = useState(false);
    const [subscriptionLoading, setSubscriptionLoading] = useState(false);
    
    const [subscription, setSubscription] = useState(null);
    // const [subscriptionNotFound, setSubscriptionNotFound] = useState(false);
    const snackbarDomRef = useRef(null);

    const setColors = useCallback((primary) => {
        let root = document.documentElement;
        root.style.setProperty('--mdc-theme-primary', primary);
        root.style.setProperty('--mdc-theme-secondary', primary);
    }, []);

    useEffect(() => {
        if (data && !subscription && !subscriptionLoading) {
            setSubscriptionLoading(true);
            if (data.token) {
                SubscriptionService.getSubscription(data.token).then((subscription) => {
                    setSubscription(subscription || data);
                    setChannelURL(subscription.url);
                    setSubscriptionLoading(false);
                }).catch((error) => {
                    setSubscription(data);
                    // setSubscriptionNotFound(true);
                })
            } else {
                setSubscription(data);
            }
        }
    }, [data, subscription, subscriptionLoading]);

    useEffect(() => {
        if (data && !config && !organizationLoading) {
            setOrganizationLoading(true);
            OrganizationService.getConfig(data.organizationId).then((config) => {
                setConfig(config);
                setOrganizationLoading(false);
            });
        }
    }, [data, config, organizationLoading]);

    useEffect(() => {
        if (config) {
            setChannel(config.organizationName);
            setColors(config.primaryColor);
        }
    }, [config, setColors]);

    // return subscriptionNotFound ? (<Navigate to="/404" replace />) : (
    return (<div className="mdc-layout-grid full-v-height" style={{ padding: 0 }}>
            <div className="mdc-layout-grid__inner full-height">
                {(subscriptionLoading && organizationLoading) && (
                    <div className="mdc-layout-grid__cell mdc-layout-grid__cell--span-12 text-center full-height flex-center">
                        <CircularProgress />
                    </div>
                )}
                {(!subscriptionLoading && !organizationLoading && subscription && isDesktopOrLaptop) && (
                    <div className="mdc-layout-grid__cell mdc-layout-grid__cell--span-7-desktop full-height" style={{ overflow: "hidden" }}>
                        <Cover imageUrl={config.mainImage} />
                    </div>
                )}
                {(!subscriptionLoading && !organizationLoading && subscription && config) && <div className="mdc-layout-grid__cell mdc-layout-grid__cell--span-5-desktop mdc-layout-grid__cell--span-4-phone">
                    {data.action === 'cancel' && <Unsubscribe data={data} subscription={subscription} config={config} channel={channel} channelURL={channelURL} snackbarDomRef={snackbarDomRef} />}
                    {data.action === 'confirm' && <Confirm data={data} subscription={subscription} config={config} channel={channel} channelURL={channelURL} snackbarDomRef={snackbarDomRef} />}
                </div>}
            </div>
            <aside ref={snackbarDomRef} className="mdc-snackbar">
                <div
                    className="mdc-snackbar__surface"
                    role="status"
                    aria-relevant="additions"
                >
                    <div className="mdc-snackbar__label" aria-atomic="false">
                        Placeholder
                    </div>
                </div>
            </aside>
        </div>
    );
});

export default Home;
